
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.shopify-product-form');

  forms.forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const fd = new FormData(form);

      try {
        // 1️⃣ Add item to cart
        const response = await fetch('/cart/add.js', { 
          method: 'POST', 
          body: fd 
        });

        if (!response.ok) {
          const err = await response.json();
          console.error('Add to cart error:', err);
          throw new Error(`Add to cart failed: ${response.status}`);
        }

        // 2️⃣ Refresh drawer and icon sections
        await refreshedCartDrawer();

        // 3️⃣ Open cart drawer depending on theme
        if (window.Shopify?.theme?.cartDrawer) {
          window.Shopify.theme.cartDrawer.open();
        } else if (window.CartDrawer?.open) {
          window.CartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

      } catch (err) {
        console.error('Add-to-cart failed:', err);
        window.location.href = '/cart';
      }
    });
  });
});


// 🔁 Drawer refresh helper
async function refreshedCartDrawer(){
  fetch('/?sections=cart-drawer,cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const parsedHTML = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const drawerInner = parsedHTML.querySelector('.drawer__inner');
    const isEmpty = drawerInner?.classList.contains('is-empty');
    console.log('isEmpty: ',isEmpty);
    const parsedState = {
      sections: {
        'cart-drawer': data['cart-drawer'],
        'cart-icon-bubble': data['cart-icon-bubble']
      },
      id: null
    };
    const cartDrawer = document.querySelector('cart-drawer');
    if(!isEmpty){
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(parsedState);
    }
  });
  
}